import type { LegalTranslations } from '../../types';

export const frLegal: LegalTranslations = {
  privacy: {
    title: 'Politique de confidentialit\u00E9',
    subtitle: 'Comment nous collectons, utilisons et prot\u00E9geons vos informations personnelles.',
    lastUpdated: 'Derni\u00E8re mise \u00E0 jour',
    effectiveDate: 'Date d\'entr\u00E9e en vigueur',
    meta: {
      lastUpdatedValue: '6 f\u00E9vrier 2026',
      effectiveDateValue: '6 f\u00E9vrier 2026',
    },
    introduction: 'Fujian Jinghui Environmental Technology Co., Ltd. (\u00AB nous \u00BB, \u00AB notre \u00BB ou \u00AB nos \u00BB) s\'engage \u00E0 prot\u00E9ger votre vie priv\u00E9e. Cette politique de confidentialit\u00E9 explique comment nous collectons, utilisons, divulguons et prot\u00E9geons vos informations lorsque vous visitez notre site Web et utilisez nos services.',
    sections: {
      infoCollect: {
        title: '1. Informations que nous collectons',
        description: 'Nous pouvons collecter des informations personnelles que vous nous fournissez volontairement lorsque vous :',
        items: [
          'Vous inscrivez sur notre site Web ou faites une demande de renseignements',
          'Demandez un devis ou des informations sur les produits',
          'Vous abonnez \u00E0 notre newsletter',
          'Contactez notre \u00E9quipe commerciale ou de support',
          'Participez \u00E0 des enqu\u00EAtes ou des promotions',
        ],
      },
      typesCollected: {
        title: '2. Types d\'informations collect\u00E9es',
        items: [
          'Informations d\'identification personnelle : Nom, adresse e-mail, num\u00E9ro de t\u00E9l\u00E9phone, nom de l\'entreprise, poste',
          'Informations d\u00E9mographiques : Pays, r\u00E9gion, pr\u00E9f\u00E9rences linguistiques',
          'Informations techniques : Adresse IP, type de navigateur, syst\u00E8me d\'exploitation, URL de r\u00E9f\u00E9rence',
          'Donn\u00E9es de communication : Messages, demandes de renseignements, retours et demandes de support',
        ],
      },
      howUse: {
        title: '3. Comment nous utilisons vos informations',
        description: 'Nous utilisons les informations que nous collectons pour :',
        items: [
          'Fournir, maintenir et am\u00E9liorer nos produits et services',
          'R\u00E9pondre \u00E0 vos demandes et fournir un support client',
          'Vous envoyer des informations sur les produits, des devis et des mat\u00E9riels promotionnels',
          'Traiter les transactions et envoyer des informations associ\u00E9es',
          'Surveiller et analyser les tendances, l\'utilisation et les activit\u00E9s',
          'D\u00E9tecter, enqu\u00EAter et pr\u00E9venir les transactions frauduleuses',
          'Se conformer aux obligations l\u00E9gales',
        ],
      },
      dataSecurity: {
        title: '4. S\u00E9curit\u00E9 des donn\u00E9es',
        description: 'Nous mettons en \u0153uvre des mesures de s\u00E9curit\u00E9 techniques et organisationnelles appropri\u00E9es pour prot\u00E9ger vos informations personnelles contre tout acc\u00E8s non autoris\u00E9, modification, divulgation ou destruction. Cependant, aucune m\u00E9thode de transmission sur Internet ou de stockage \u00E9lectronique n\'est s\u00E9curis\u00E9e \u00E0 100 %.',
        encryption: 'Nous utilisons un chiffrement conforme aux normes de l\'industrie (SSL/TLS) pour prot\u00E9ger les donn\u00E9es transmises entre votre navigateur et nos serveurs.',
      },
      cookies: {
        title: '5. Cookies et technologies de suivi',
        description: 'Notre site Web peut utiliser des cookies, des balises Web et des technologies de suivi similaires pour collecter des informations sur vos activit\u00E9s de navigation. Vous pouvez configurer votre navigateur pour refuser tous les cookies ou indiquer quand un cookie est envoy\u00E9.',
      },
      thirdParty: {
        title: '6. Divulgation \u00E0 des tiers',
        description: 'Nous ne vendons, n\'\u00E9changeons ni ne transf\u00E9rons autrement vos informations personnellement identifiables \u00E0 des tiers, sauf dans les circonstances suivantes :',
        items: [
          'Avec des prestataires de services qui assistent nos op\u00E9rations commerciales',
          'Lorsque requis par la loi, une assignation ou autre proc\u00E9dure l\u00E9gale',
          'Pour prot\u00E9ger nos droits, notre vie priv\u00E9e, notre s\u00E9curit\u00E9 ou nos biens',
          'Dans le cadre d\'une fusion, acquisition ou vente d\'actifs',
        ],
      },
      dataRetention: {
        title: '7. Conservation des donn\u00E9es',
        description: 'Nous conserverons vos informations personnelles aussi longtemps que n\u00E9cessaire pour atteindre les objectifs \u00E9nonc\u00E9s dans cette politique de confidentialit\u00E9, \u00E0 moins qu\'une p\u00E9riode de conservation plus longue ne soit requise ou autoris\u00E9e par la loi.',
      },
      yourRights: {
        title: '8. Vos droits',
        description: 'Vous avez le droit de :',
        items: [
          'Acc\u00E9der \u00E0 vos donn\u00E9es personnelles et en recevoir une copie',
          'Rectifier les donn\u00E9es personnelles inexactes',
          'Demander la suppression de vos donn\u00E9es personnelles',
          'Vous opposer au traitement de vos donn\u00E9es personnelles',
          'Demander la restriction du traitement',
          '\u00C0 la portabilit\u00E9 des donn\u00E9es',
        ],
      },
      children: {
        title: '9. Confidentialit\u00E9 des enfants',
        description: 'Notre site Web n\'est pas destin\u00E9 aux enfants de moins de 16 ans. Nous ne collectons pas sciemment d\'informations personnelles d\'enfants de moins de 16 ans.',
      },
      international: {
        title: '10. Transferts internationaux de donn\u00E9es',
        description: 'Vos informations peuvent \u00EAtre transf\u00E9r\u00E9es et trait\u00E9es dans des pays autres que votre pays de r\u00E9sidence. Ces pays peuvent avoir des lois sur la protection des donn\u00E9es diff\u00E9rentes de celles de votre pays.',
      },
      changes: {
        title: '11. Modifications de cette politique',
        description: 'Nous pouvons mettre \u00E0 jour cette politique de confidentialit\u00E9 de temps \u00E0 autre. Nous vous informerons de tout changement en publiant la nouvelle politique de confidentialit\u00E9 sur cette page et en mettant \u00E0 jour la date de \u00AB Derni\u00E8re mise \u00E0 jour \u00BB en haut de cette politique.',
      },
      contactUs: {
        title: '12. Contactez-nous',
        description: 'Si vous avez des questions concernant cette politique de confidentialit\u00E9 ou nos pratiques en mati\u00E8re de donn\u00E9es, veuillez nous contacter :',
        email: 'E-mail',
        address: 'Adresse',
        company: 'Fujian Jinghui Environmental Technology Co., Ltd.',
        addressLine: 'B\u00E2timent 25, Parc scientifique et technologique Wanyang, 26 Tingwang Road, Tingjiang Town, District de Mawei, Fuzhou, Fujian, Chine',
      },
    },
  },
  terms: {
    title: 'Conditions d\'utilisation',
    subtitle: 'Veuillez lire attentivement ces conditions avant d\'utiliser notre site Web et nos services.',
    lastUpdated: 'Derni\u00E8re mise \u00E0 jour',
    effectiveDate: 'Date d\'entr\u00E9e en vigueur',
    meta: {
      lastUpdatedValue: '6 f\u00E9vrier 2026',
      effectiveDateValue: '6 f\u00E9vrier 2026',
    },
    introduction: 'Bienvenue sur le site Web de Fujian Jinghui Environmental Technology Co., Ltd. En acc\u00E9dant \u00E0 ce site Web ou en l\'utilisant, vous acceptez d\'\u00EAtre li\u00E9 par ces conditions d\'utilisation et toutes les lois et r\u00E9glementations applicables. Si vous n\'acceptez pas une partie de ces conditions, vous ne pouvez pas utiliser notre site Web.',
    importantNotice: {
      title: 'Avis important',
      description: 'En utilisant ce site Web, vous reconnaissez avoir lu, compris et accept\u00E9 d\'\u00EAtre li\u00E9 par ces conditions d\'utilisation. Si vous utilisez ce site Web au nom d\'une entreprise ou d\'une organisation, vous d\u00E9clarez avoir l\'autorit\u00E9 de lier cette entit\u00E9 \u00E0 ces conditions.',
    },
    sections: {
      useWebsite: {
        title: '1. Utilisation du site Web',
        description: 'Ce site Web est fourni par Fujian Jinghui Environmental Technology Co., Ltd. \u00E0 des fins d\'information uniquement. En utilisant ce site Web, vous acceptez de :',
        items: [
          'Utiliser le site Web uniquement \u00E0 des fins l\u00E9gales et conform\u00E9ment \u00E0 ces conditions',
          'Ne pas utiliser le site Web d\'une mani\u00E8re qui pourrait endommager, d\u00E9sactiver, surcharger ou alt\u00E9rer le site',
          'Ne pas tenter d\'obtenir un acc\u00E8s non autoris\u00E9 \u00E0 une partie du site Web',
          'Ne pas utiliser le site Web pour transmettre des virus, vers ou code nuisible',
          'Respecter les droits de propri\u00E9t\u00E9 intellectuelle de JH Heatsup et des autres',
        ],
      },
      intellectualProperty: {
        title: '2. Droits de propri\u00E9t\u00E9 intellectuelle',
        description: 'Tout le contenu de ce site Web, y compris mais sans s\'y limiter les textes, graphiques, logos, images, extraits audio, t\u00E9l\u00E9chargements num\u00E9riques et logiciels, est la propri\u00E9t\u00E9 de Fujian Jinghui Environmental Technology Co., Ltd. ou de ses fournisseurs de contenu et est prot\u00E9g\u00E9 par le droit d\'auteur international, les marques d\u00E9pos\u00E9es et d\'autres lois sur la propri\u00E9t\u00E9 intellectuelle.',
        restriction: 'Vous ne pouvez pas reproduire, distribuer, modifier, cr\u00E9er des \u0153uvres d\u00E9riv\u00E9es, afficher publiquement, ex\u00E9cuter publiquement ou exploiter tout contenu de ce site Web sans notre consentement \u00E9crit pr\u00E9alable.',
      },
      productInfo: {
        title: '3. Informations sur les produits et prix',
        description: 'Tous les produits et services pr\u00E9sent\u00E9s sur ce site Web sont soumis \u00E0 disponibilit\u00E9. Nous nous r\u00E9servons le droit d\'interrompre tout produit ou service \u00E0 tout moment.',
        pricing: 'Les prix et les sp\u00E9cifications sont susceptibles de changer sans pr\u00E9avis. Nous faisons tout notre possible pour assurer l\'exactitude des informations sur les produits, mais des erreurs peuvent survenir. Nous nous r\u00E9servons le droit de corriger toute erreur, inexactitude ou omission et de modifier ou mettre \u00E0 jour les informations \u00E0 tout moment.',
        currency: 'Tous les prix sont indiqu\u00E9s en USD sauf indication contraire. Les frais de port, taxes et droits sont suppl\u00E9mentaires et seront calcul\u00E9s lors du processus de commande.',
      },
      quotesOrders: {
        title: '4. Devis et commandes',
        description: 'Les devis fournis par ce site Web sont valables 30 jours sauf indication contraire. Toutes les commandes sont soumises \u00E0 l\'acceptation de JH Heatsup.',
        contract: 'En soumettant une commande, vous acceptez d\'acheter les produits conform\u00E9ment \u00E0 nos conditions en vigueur, y compris les conditions de prix, d\'exp\u00E9dition et de paiement. Un contrat contraignant n\'est form\u00E9 que lorsque nous confirmons l\'acceptation de votre commande.',
      },
      warranties: {
        title: '5. Garanties et exclusions',
        description: 'CE SITE WEB ET TOUT LE CONTENU, PRODUITS ET SERVICES FOURNIS PAR SON INTERM\u00C9DIAIRE SONT FOURNIS \u00AB EN L\'\u00C9TAT \u00BB ET \u00AB SELON DISPONIBILIT\u00C9 \u00BB SANS GARANTIES D\'AUCUNE SORTE, EXPRESSES OU IMPLICITES.',
        disclaimer: 'JH HEATER D\u00C9CLINE TOUTE GARANTIE, EXPRESSE OU IMPLICITE, Y COMPRIS MAIS SANS S\'Y LIMITER LES GARANTIES IMPLICITES DE QUALIT\u00C9 MARCHANDE, D\'ADAPTATION \u00C0 UN USAGE PARTICULIER, DE TITRE ET DE NON-CONTREFA\u00C7ON. Nous ne garantissons pas que le site Web sera ininterrompu, ponctuel, s\u00E9curis\u00E9 ou sans erreur.',
      },
      liability: {
        title: '6. Limitation de responsabilit\u00E9',
        description: 'EN AUCUN CAS FUJIAN JINGHUI ENVIRONMENT TECHNOLOGY CO., LTD., SES DIRIGEANTS, ADMINISTRATEURS, EMPLOY\u00C9S OU AGENTS NE SERONT RESPONSABLES DE TOUT DOMMAGE INDIRECT, ACCESSOIRE, SP\u00C9CIAL, CONS\u00C9CUTIF OU PUNITIF D\u00C9COULANT DE OU LI\u00C9 \u00C0 VOTRE UTILISATION DE CE SITE WEB OU DE TOUT PRODUIT OU SERVICE ACHET\u00C9 AUPR\u00C8S DE NOUS.',
        limit: 'Notre responsabilit\u00E9 totale pour toute r\u00E9clamation d\u00E9coulant de ou li\u00E9e \u00E0 ces conditions ou \u00E0 nos produits et services ne d\u00E9passera pas le montant pay\u00E9 par vous pour les produits ou services \u00E0 l\'origine de ladite r\u00E9clamation.',
      },
      privacy: {
        title: '7. Politique de confidentialit\u00E9',
        description: 'Votre utilisation de ce site Web \u00E9galement r\u00E9gie par notre politique de confidentialit\u00E9, qui est int\u00E9gr\u00E9e \u00E0 ces conditions par r\u00E9f\u00E9rence. Veuillez consulter notre politique de confidentialit\u00E9 pour comprendre comment nous collectons, utilisons et prot\u00E9geons vos informations.',
      },
      thirdPartyLinks: {
        title: '8. Liens tiers',
        description: 'Ce site Web peut contenir des liens vers des sites Web tiers qui ne sont ni d\u00E9tenus ni contr\u00F4l\u00E9s par JH Heatsup. Nous n\'avons aucun contr\u00F4le sur le contenu, les politiques de confidentialit\u00E9 ou les pratiques de tout site Web tiers et n\'assumons aucune responsabilit\u00E9 \u00E0 cet \u00E9gard. Vous acc\u00E9dez \u00E0 ces liens \u00E0 vos propres risques.',
        recommendation: 'Nous vous encourageons \u00E0 consulter les conditions et la politique de confidentialit\u00E9 de tout site Web tiers que vous visitez.',
      },
      governingLaw: {
        title: '9. Loi applicable et litiges',
        description: 'Ces conditions seront r\u00E9gies et interpr\u00E9t\u00E9es conform\u00E9ment aux lois de la R\u00E9publique populaire de Chine, sans \u00E9gard \u00E0 ses dispositions en mati\u00E8re de conflits de lois.',
        disputes: 'Tout litige d\u00E9coulant de ou li\u00E9 \u00E0 ces conditions ou \u00E0 votre utilisation de ce site Web sera r\u00E9solu par des n\u00E9gociations de bonne foi entre les parties. Si ces n\u00E9gociations \u00E9chouent, le litige sera soumis \u00E0 un arbitrage contraignant conform\u00E9ment aux r\u00E8gles de la Commission chinoise d\'arbitrage \u00E9conomique et commercial international.',
      },
      export: {
        title: '10. Contr\u00F4les \u00E0 l\'exportation',
        description: 'Vous acceptez de vous conformer \u00E0 toutes les lois et r\u00E9glementations applicables en mati\u00E8re de contr\u00F4le \u00E0 l\'exportation. Vous d\u00E9clarez ne pas \u00EAtre situ\u00E9 dans, sous le contr\u00F4le de, ou ressortissant ou r\u00E9sident de tout pays soumis \u00E0 des sanctions ou embargos am\u00E9ricains complets.',
      },
      termination: {
        title: '11. R\u00E9siliation',
        description: 'Nous pouvons r\u00E9silier ou suspendre votre acc\u00E8s \u00E0 ce site Web imm\u00E9diatement, sans pr\u00E9avis ni responsabilit\u00E9, pour quelque raison que ce soit, y compris le manquement \u00E0 ces conditions. En cas de r\u00E9siliation, votre droit d\'utiliser le site Web cessera imm\u00E9diatement.',
      },
      changes: {
        title: '12. Modifications de ces conditions',
        description: 'Nous nous r\u00E9servons le droit de modifier ou de remplacer ces conditions \u00E0 tout moment. Si une r\u00E9vision est importante, nous fournirons un pr\u00E9avis de 30 jours avant l\'entr\u00E9e en vigueur des nouvelles conditions. Votre utilisation continue du site Web apr\u00E8s de tels changements constitue l\'acceptation des nouvelles conditions.',
      },
      severability: {
        title: '13. Divisibilit\u00E9',
        description: 'Si une disposition de ces conditions est jug\u00E9e invalide, ill\u00E9gale ou inapplicable, cette disposition sera modifi\u00E9e dans la mesure minimale n\u00E9cessaire pour la rendre applicable, et les autres dispositions continueront \u00E0 avoir plein effet.',
      },
      contactUs: {
        title: '14. Coordonn\u00E9es',
        description: 'Si vous avez des questions concernant ces conditions d\'utilisation, veuillez nous contacter :',
        email: 'E-mail',
        address: 'Adresse',
        company: 'Fujian Jinghui Environmental Technology Co., Ltd.',
        addressLine: 'B\u00E2timent 25, Parc scientifique et technologique Wanyang, 26 Tingwang Road, Tingjiang Town, District de Mawei, Fuzhou, Fujian, Chine',
      },
    },
  },
  installationGuide: {
    header: {
      title: "Guide d'installation",
      subtitle: 'Suivez ces étapes pour installer votre appareil JH Heatsup de manière sûre et efficace.',
    },
    safety: {
      title: "La sécurité avant tout",
      description: "L'installation doit être réalisée par un électricien qualifié conformément aux normes électriques locales. Coupez toujours l'alimentation au tableau électrique principal avant de commencer.",
    },
    toolsTitle: 'Outils nécessaires',
    tools: {
      electricDrill: 'Perceuse électrique',
      screwdriver: 'Tournevis',
      level: 'Niveau',
      measuringTape: 'Mètre ruban',
      wireStrippers: 'Pince à dénuder',
      ladder: 'Escabeau',
    },
    stepsTitle: "Étapes d'installation",
    steps: {
      step1: {
        title: 'Positionnement et mesures',
        description: "Choisissez un emplacement au plafond ou en hauteur sur un mur. Pour un rendement optimal, installez le radiateur entre 2,2 m et 2,5 m du sol. Marquez les points de perçage selon les dimensions du support fourni.",
        bullet1: 'Conservez une distance minimale de 0,5 m avec les murs latéraux.',
        bullet2: "Conservez une distance minimale de 0,2 m avec le plafond en cas d'installation murale.",
      },
      step2: {
        title: 'Fixation des supports',
        description: "Percez les trous aux emplacements marqués et insérez les chevilles à expansion. Fixez solidement les supports. Faites glisser les supports arrière du radiateur dans les supports muraux, puis serrez les vis de réglage selon l'angle souhaité : 0°, 15°, 30° ou 45°.",
      },
      step3: {
        title: 'Raccordement électrique',
        description: "Raccordez le câble au secteur et vérifiez la mise à la terre. Pour les modèles avec télécommande, veillez à ce que le récepteur infrarouge reste visible.",
        wireLive: 'L — Phase',
        wireLiveColor: 'Marron',
        wireNeutral: 'N — Neutre',
        wireNeutralColor: 'Bleu',
        wireEarth: 'E — Terre',
        wireEarthColor: 'Jaune / Vert',
      },
      step4: {
        title: 'Essai',
        description: "Rétablissez l'alimentation. Le radiateur doit atteindre sa température de fonctionnement en cinq minutes. Une légère odeur peut apparaître lors de la première utilisation ; elle est normale et disparaît rapidement.",
      },
    },
    download: {
      title: 'Consulter le manuel du produit',
      subtitle: "Accédez au manuel d'installation complet et aux schémas correspondant à votre modèle.",
      jhnr: 'Voir le manuel',
      industrial: 'Voir le manuel',
    },
  },
  warrantyPolicy: {
    header: {
      title: 'Politique de garantie',
      subtitle: 'Notre engagement en faveur de la qualité et de votre tranquillité.',
    },
    overview: {
      standardCoverage: 'Garantie standard',
      standardCoverageDesc: "Les produits JH Heatsup sont garantis contre les défauts de matériaux et de fabrication dans des conditions normales d'utilisation.",
      warrantyPeriod: 'Durée de la garantie',
      residentialPeriod: '2 ans pour les radiateurs résidentiels.',
      industrialPeriod: '1 an pour les radiateurs industriels et les contrôleurs.',
    },
    sections: {
      scope: {
        title: '1. Étendue de la garantie',
        description: "Cette garantie s'applique à l'acheteur initial et n'est pas transférable. Elle couvre la réparation ou le remplacement de toute pièce présentant un défaut de matériau ou de fabrication pendant la période de garantie.",
      },
      notCovered: {
        title: "2. Éléments non couverts",
        description: 'Cette garantie ne couvre pas les dommages résultant des situations suivantes :',
        item1: "Installation incorrecte ou non conforme au manuel fourni.",
        item2: 'Mauvaise utilisation, usage abusif, négligence ou accident.',
        item3: 'Altération ou modification du produit.',
        item4: 'Surtension ou foudre.',
        item5: "Usure normale, notamment la décoloration progressive de la surface.",
      },
      claim: {
        title: '3. Demande de garantie',
        description: 'Pour obtenir une prise en charge, contactez notre équipe avec les informations suivantes :',
        proofOfPurchase: "Preuve d'achat (facture ou reçu)",
        defectDescription: 'Description et photos ou vidéo du défaut',
        serialNumber: "Numéro de série de l'appareil",
        contactEmail: 'Adresse e-mail de contact',
      },
    },
  },
};
